import dayjs from 'dayjs';
import type { AppAdminTenancySchemasContractContractOut } from '@/api/generated/schemas';

export type ContractOut = AppAdminTenancySchemasContractContractOut;

export const CONTRACT_SHOW_TABS = ['general'] as const;
export type ContractShowTab = (typeof CONTRACT_SHOW_TABS)[number];
export const CONTRACT_DEFAULT_TAB: ContractShowTab = 'general';

/** Contracts become immutable once effective: edit/delete only while
 * `valid_from` is still a future day (same boundary as the form picker). */
export const isContractEditable = (contract: ContractOut) =>
  dayjs(contract.valid_from).isAfter(dayjs(), 'day');
